import { SectionsEnum } from '../enums/sections.enum';

export const MenuTitlesDictionary: Record<SectionsEnum, string> = {
    [SectionsEnum.DATA_COLLECTION_FORMS]: 'My Froms',
    [SectionsEnum.DATA_COLLECTION_INSPECTION]: 'Data collection',
    [SectionsEnum.DATA_COLLECTION_INSPECTIONS]: 'Data collection',
    [SectionsEnum.DATA_COLLECTION_SURVEYS]: 'Surveys',
};
